<div class="assessment-connections-container">
  <div class="section-header">
    <h3>Assessments</h3>
    <button mat-raised-button color="primary" (click)="createAssessment()" [disabled]="isViewer()">
      <mat-icon>add</mat-icon>
      New Assessment
    </button>
  </div>

  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (assessments.length === 0) {
    <mat-card class="empty-state">
      <mat-card-content>
        <mat-icon>assessment</mat-icon>
        <p>{{ loadError || 'No assessments found' }}</p>
      </mat-card-content>
    </mat-card>
  } @else {
    <table mat-table [dataSource]="assessments" class="assessments-table">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <mat-chip-set>
            <mat-chip>{{ row.status || 'Pending' }}</mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <ng-container matColumnDef="assessor">
        <th mat-header-cell *matHeaderCellDef>Assessor</th>
        <td mat-cell *matCellDef="let row">{{ getAssessorName(row.assessor) }}</td>
      </ng-container>

      <ng-container matColumnDef="totalScore">
        <th mat-header-cell *matHeaderCellDef>Total Score</th>
        <td mat-cell *matCellDef="let row">{{ totalScore(row) }}</td>
      </ng-container>

      <ng-container matColumnDef="criticalDate">
        <th mat-header-cell *matHeaderCellDef>Due Date</th>
        <td mat-cell *matCellDef="let row">
          @if (row.criticalDate) {
            {{ row.criticalDate | date:'MM/dd/yyyy' }}
          } @else {
            —
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="assessment-row"
          (click)="viewAssessment(row)"></tr>
    </table>
  }
</div>
